import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import i18n from "@microdoing/shared/i18n";
import { MainText, Box, MainTitle } from "app/components/common";
import Badge from "./Badge";
import achievementBadges from "./achievementBadges";
import AchievementModal from "../../../components/common/AchievementModal";
import { useScreenLoading } from "../hooks";
import { UserProfileBlock } from "../UserProfileBlock";

const styles = StyleSheet.create({
  allBadgeView: {
    zIndex: 1,
    overflow: "hidden",
    width: "100%",
    alignSelf: "center",
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
});

const getAchievementTotal = badgeArray => {
  const total = badgeArray.reduce((prev, curr) => {
    if (curr.level > 0) {
      prev = prev + 1;
    }
    return prev;
  }, 0);
  return total;
};

const Badges = ({ achievements }) => {
  const [isScreenLoading] = useScreenLoading();
  const [badgeSelected, setBadge] = useState(null);

  const showBadgeExplanation = el => () => {
    setBadge(el);
  };

  const achievementsArray = Object.keys(achievements).map(
    el => achievements[el],
  );

  if (isScreenLoading) return null;

  return (
    <>
      <AchievementModal
        title={
          badgeSelected?.level > 0
            ? i18n.t("feat-unlocked")
            : i18n.t("unlock-feat")
        }
        {...badgeSelected}
        isEmpty={badgeSelected?.level < 1}
        isVisible={Boolean(badgeSelected)}
        triggerModal={() => setBadge(null)}
      />
      <UserProfileBlock
        title={<MainTitle variant="l6-bold">{i18n.t("feat")}</MainTitle>}
        headerContent={
          <MainText variant="l3-medium">
            {`${getAchievementTotal(achievementsArray)} / ${
              achievementsArray.length
            }`}
          </MainText>
        }
        mainContent={
          <Box style={styles.allBadgeView}>
            {achievementsArray.map(el => (
              <Badge
                key={el.name}
                level={el.level}
                onPress={showBadgeExplanation(el)}
                BadgeIcon={achievementBadges[el.level > 0 ? el.name : "empty"](
                  70,
                )}
              />
            ))}
          </Box>
        }
      />
    </>
  );
};

export default Badges;
